import { render, staticRenderFns } from "./masterBasicTab.vue?vue&type=template&id=ceaeb660&scoped=true&"
import script from "./masterBasicTab.vue?vue&type=script&lang=js&"
export * from "./masterBasicTab.vue?vue&type=script&lang=js&"
import style0 from "./masterBasicTab.vue?vue&type=style&index=0&id=ceaeb660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaeb660",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceaeb660')) {
      api.createRecord('ceaeb660', component.options)
    } else {
      api.reload('ceaeb660', component.options)
    }
    module.hot.accept("./masterBasicTab.vue?vue&type=template&id=ceaeb660&scoped=true&", function () {
      api.rerender('ceaeb660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/masterBasicTab.vue"
export default component.exports